export default {"reviewsSkin1":"WPvvf","productRating":"uskVj","content":"Tc4Du","reviewBox":"IeYvB","controls":"lzfi0"};